import React, { useState } from 'react';
import { Button } from 'antd';
import { Select as AntdSelect } from 'antd';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { Select } from 'antd';
const { Option } = Select;

export default function ArtistDetailsStep({
  onChange,
  nftDetails,
  formStep,
  steps,
  next,
  prev,
  setartistDialogState,
  artistList,
  setArtistId,
  userP2DetailsExist,
  userP2Details = {},
  selectedArtist,
  setSelectedArtist,
}) {
  const renderStepperActions = () => {
    const { artistId } = nftDetails;
    return (
      <>
        {formStep > 0 && (
          <Button
            className="step_btn_btn"
            style={{ margin: '0 8px' }}
            onClick={() => prev()}
          >
            Prev
          </Button>
        )}
        {formStep < steps.length - 1 && (
          <Button
            className="step_btn_btn"
            disabled={
              !artistId || !(userP2DetailsExist && userP2Details.issuerContact)
            }
            type="primary"
            onClick={() => next()}
          >
            Next
          </Button>
        )}
      </>
    );
  };

  return (
    <>
      <div className="steps-content-inner-wrapper">
        <div className="w-full">
          <h4 className="sign__title">MusicArtists details</h4>
        </div>

        <div className="w-full lg:px-4">
          <div className="sign__group">
            <label
              className="sign__label sign_label_label"
              htmlFor="collectionSelect"
            >
              Select MusicArtist <span className="text-red-500">*</span>
            </label>
            <div className="collection_select">
              <AntdSelect
                showSearch
                style={{ width: '100%' }}
                placeholder="Select a person"
                optionFilterProp="children"
                onChange={(e) => {
                  let selectedArtist = artistList.find((a) => a.artistId === e);
                  setSelectedArtist(selectedArtist);
                  setArtistId(e, selectedArtist.name);
                }}
                value={nftDetails.artistId}
                filterOption={(input, option) =>
                  option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
              >
                {artistList
                  .sort(function (a, b) {
                    if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
                    if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
                    return 0;
                  })
                  .map((item, index) => {
                    return (
                      <Option
                        value={item.artistId}
                        key={item.name + index}
                        name={item.name}
                      >
                        <div
                          style={{
                            display: 'flex',
                            width: '100%',
                            flexDirection: 'row',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            style={{
                              width: '30px',
                              height: '30px',
                              minHeight: '30px',
                              maxHeight: 'auto',
                              minWidth: '30px',
                              marginRight: '5px',
                            }}
                          >
                            <img
                              className="profile_icon inline-block ring-2 ring-white"
                              style={{
                                width: '100%',
                                height: 'auto',
                              }}
                              src={
                                item.photoUrl && !item.photoUrl.includes('blob')
                                  ? item.photoUrl + '_250x250?alt=media'
                                  : item.photoUrl
                              }
                            />
                          </div>

                          <div className="profile_text_wrapper">
                            {' '}
                            {item.name}
                          </div>
                          <div
                            style={{
                              marginLeft: 'auto',
                              paddingLeft: 10,
                            }}
                          >
                            <OpenInNewIcon
                              style={{
                                width: 15,
                                height: 15,
                              }}
                              className="link"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                window.open('/artist/' + item.artistId);
                              }}
                            />
                          </div>
                        </div>
                      </Option>
                    );
                  })}
              </AntdSelect>
              <div style={{ marginTop: 3, marginLeft: 2 }}>
                Didn't find the MusicArtist!{' '}
                <span
                  onClick={() => setartistDialogState(true)}
                  className="link link_text"
                >
                  Create New MusicArtist
                </span>
              </div>
              <div className="w-full flex justify-center items-center flex-col space-y-3 mt-3">
                <div>
                  {selectedArtist.photoUrl && (
                    <div
                      style={{
                        width: '150px',
                        height: '150px',
                      }}
                    >
                      <img
                        className="profile_icon inline-block ring-2 ring-white"
                        style={{
                          width: '100%',
                          height: 'auto',
                          borderRadius: '50%',
                        }}
                        src={
                          selectedArtist.photoUrl &&
                          !selectedArtist.photoUrl.includes('blob')
                            ? selectedArtist.photoUrl + '_250x250?alt=media'
                            : selectedArtist.photoUrl
                        }
                      />
                    </div>
                  )}
                </div>
                <div className="w-full md:w-4/12 px-4">
                  <div className="text-center py-3">
                    <h4 className="text-lg">{selectedArtist.name}</h4>
                  </div>
                </div>
                <div>
                  <div className="w-full px-4">
                    <p
                      style={{
                        wordBreak: 'break-word',
                      }}
                    >
                      {selectedArtist.bio}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center mt-10">
                {selectedArtist.spotify && (
                  <div className="mx-2">
                    <div className="artist_profile_details">
                      {/* <span className="sign__label">Spotify</span> */}
                      <a href={selectedArtist.spotify} target="_blank">
                        {' '}
                        <img src="/img/clipart352579.png" />{' '}
                      </a>
                      {/* <p className="font-semibold"></p> */}
                    </div>
                  </div>
                )}
                {selectedArtist.apple && (
                  <div className="mx-2">
                    <div className="artist_profile_details">
                      {/* <span className="sign__label">Apple</span> */}
                      <a href={selectedArtist.apple} target="_blank">
                        {' '}
                        <img src="/img/clipart1190019.png" />{' '}
                      </a>

                      {/* <p className="font-semibold"></p> */}
                    </div>
                  </div>
                )}
                {selectedArtist.twitter && (
                  <div className="mx-2">
                    <div className="artist_profile_details">
                      {/* <span className="sign__label">Twitter</span> */}
                      <a href={selectedArtist.twitter}>
                        {' '}
                        <img src="/img/twitter.png" />{' '}
                      </a>
                      {/* <p className="font-semibold"></p> */}
                    </div>
                  </div>
                )}
                {selectedArtist.tiktok && (
                  <div className="mx-2">
                    <div className="artist_profile_details">
                      {/* <span className="sign__label">Tiktok</span> */}
                      <a href={selectedArtist.tiktok}>
                        {' '}
                        <img src="/img/tik-tok.png" />{' '}
                      </a>

                      {/* <p className="font-semibold"></p> */}
                    </div>
                  </div>
                )}
                {selectedArtist.facebook && (
                  <div className=" ">
                    <div className="artist_profile_details">
                      {/* <span className="sign__label">Facebook</span> */}
                      <a href={selectedArtist.facebook}>
                        {' '}
                        <img src="/img/clipart171363.png" />{' '}
                      </a>

                      <p className="font-semibold"></p>
                    </div>
                  </div>
                )}
                {selectedArtist.instagram && (
                  <div className="mx-2">
                    <div className="artist_profile_details">
                      {/* <span className="sign__label">Instagram</span> */}
                      <a href={selectedArtist.instagram}>
                        {' '}
                        <img src="/img/clipart41427.png" />{' '}
                      </a>

                      <p className="font-semibold"></p>
                    </div>
                  </div>
                )}
                {selectedArtist.aurovine && (
                  <div className="mx-2">
                    <div className="artist_profile_details">
                      {/* <span className="sign__label">Aurovine</span> */}
                      <a href={selectedArtist.aurovine}>
                        {' '}
                        <img src="/img/Aurovine.jpg" />{' '}
                      </a>

                      <p className="font-semibold"></p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="steps-action px-4">{renderStepperActions()}</div>
    </>
  );
}
